// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { useEffect, useState } from 'react';
import * as S from './PlatformFlag.styled';

const PlatformFlag = () => {
  const [platform, setPlatform] = useState('');

  useEffect(() => {
    const value = window.ENV?.NEXT_PUBLIC_PLATFORM;
    if (value && value !== 'undefined' && value !== 'local') {
      setPlatform(value);
    }
  }, []);

  if (!platform) {
    return null;
  }

  return <S.Block>{platform}</S.Block>;
};

export default PlatformFlag;
